__turbopack_context__.v({
  "teamMemberName": "ProjectMetaSection-module__ifMVia__teamMemberName",
  "teamMemberRole": "ProjectMetaSection-module__ifMVia__teamMemberRole",
});
